import { render, staticRenderFns } from "./CreatePDF.vue?vue&type=template&id=dc379d24&"
import script from "./CreatePDF.vue?vue&type=script&lang=ts&"
export * from "./CreatePDF.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePDF.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports